import { render } from "./add_customer_account_model.vue?vue&type=template&id=2dbb1fc2"
import script from "./add_customer_account_model.vue?vue&type=script&lang=js"
export * from "./add_customer_account_model.vue?vue&type=script&lang=js"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__